module.exports = __webpack_public_path__ + "static/NotoSans-Bold-98f0cacc6bb63b64b98aac7cac082d27.ttf";